<template>
  <article class="event-company-profile">
    <h3 class="event-company-profile__header">
      {{ $t("event.companyProfile.title") }}

      <icon
        name="event-company-profile-header"
        class="event-company-profile__header-icon"
      />
    </h3>

    <div class="event-company-profile__content">
      <div class="event-company-profile__company-info">
        <div class="event-company-profile__company-info-logo">
          <template v-if="companyImage">
            <img :src="companyImage" :alt="companyName" />
          </template>

          <template v-else>
            <img
              src="/public/static/images/event-no-company-image.svg"
              :alt="companyName"
            />
          </template>
        </div>

        <div>
          <h4 class="event-company-profile__company-info-name">
            {{ companyName }}
          </h4>

          <p class="event-company-profile__company-info-type">
            {{ participantType }}
          </p>
        </div>
      </div>

      <div class="event-company-profile__status">
        <DotText class="_success" v-if="hasCompleteCompany">
          {{ $t("event.companyProfile.profileComplete") }}
        </DotText>

        <DotText class="_warning" v-else>
          {{ $t("event.companyProfile.profileNotComplete") }}
        </DotText>
      </div>

      <div class="event-company-profile__action" v-if="hasAccessToWrite">
        <template v-if="hasCompleteCompany">
          <LinkIcon
            icon="link-icon-edit"
            @click="$modal.show('event-modal-company-profile')"
            :bold="true"
          >
            {{ $t("common.editBtn") }}
          </LinkIcon>
        </template>

        <template v-else>
          <PrimaryButton @click="$modal.show('event-modal-company-profile')">
            {{ $t("common.fillBtn") }}
          </PrimaryButton>
        </template>
      </div>

      <div class="event-company-profile-action" style="margin-top: 25px" v-else>
        <LinkIcon
          icon="look"
          @click="$modal.show('event-modal-company-profile')"
          :bold="true"
        >
          {{ $t("common.lookBtn") }}
        </LinkIcon>
      </div>
    </div>
  </article>
</template>

<script>
import image from "/public/static/images/event-no-company-image.svg";
import { mapState, mapGetters } from "vuex";
import { i18n } from "@v2/shared/config";
import { LinkIcon, PrimaryButton, DotText } from "@v2/shared/ui/components";

export default {
  name: "EventCompanyProfile",

  components: { LinkIcon, PrimaryButton, DotText },

  data() {
    return {
      noPhoto: image
    };
  },

  computed: {
    ...mapState("event", ["event"]),

    ...mapGetters("event", [
      "hasAccessToWrite",
      "participantType",
      "hasCompleteCompany"
    ]),

    companyName() {
      if (!(this.event && this.event.company)) {
        return "";
      }

      const ru = this.event.company.name_rus,
        eng = this.event.company.name_eng;

      return i18n.locale === "en" && eng ? eng : ru;
    },

    companyImage() {
      if (
        this.event.company &&
        this.event.company.image &&
        this.event.company.image.thumbnail_path
      ) {
        return `${process.env.VUE_APP_URL}storage/${this.event.company.image.thumbnail_path}`;
      }

      return this.noPhoto;
    }
  }
};
</script>

<style lang="scss">
@import "@v2/app/styles/mixins";
@import "@v2/app/styles/media";

.event-company-profile {
  width: 300px;
  min-height: 302px;
  @include respond-down(lg) {
    width: 258px;
  }

  margin-top: 24px;

  box-sizing: border-box;

  @include respond-down(md) {
    margin-top: 0;
    min-height: 240px;
  }

  &__header {
    @include h2();

    padding: 20px 30px;

    @include respond-down(md) {
      padding: 15px;
      font-size: 1rem;
    }

    border-bottom: 1px solid var(--gray-darker);

    position: relative;
    overflow: hidden;

    &-icon {
      position: absolute;
      right: -9%;
      top: 50%;

      transform: translateY(-50%);

      width: 80px;
      height: 80px;

      @include respond-down(lg) {
        display: none;
      }
      @include respond-down(md) {
        display: block;
        right: 8px;
        width: 56px;
        height: 56px;
      }
    }
  }

  &__content {
    padding: 30px;

    @include respond-down(lg) {
      padding: 30px;
    }

    @include respond-down(md) {
      padding: 15px;
    }
  }

  &__company-info {
    display: flex;

    &-logo {
      width: 56px;
      height: 56px;
      background: #f6f6f6;
      border-radius: 50%;
      margin-right: 18px;

      flex-shrink: 0;

      overflow: hidden;

      display: flex;
      align-items: center;
      justify-content: center;

      img {
        max-width: 100%;
      }
    }

    &-name {
      font-size: 14px;
      font-weight: 500;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.43;
      letter-spacing: normal;
      color: #000000;
      margin: 3px 0 7px -1px;
      width: 180px;
      text-overflow: ellipsis;
      overflow: hidden;
      @include respond-down(lg) {
        width: 140px;
      }
      @include respond-down(md) {
        width: auto;
      }
      @include respond-down(xs) {
        width: 200px;
      }
    }

    &-type {
      font-size: 13px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.54;
      letter-spacing: normal;
      color: #6d7179;
      margin: 0;
    }
  }

  &__status {
    margin: 37px 0 0 1px;
  }

  &__action {
    margin-top: 16px;
  }
}
</style>
